module.exports = __webpack_public_path__ + "assets/img/card_4.fbe8b71c.png";